<template>
  <NavBar class="navbar">
    <template #left>
      <RoundedIcon
        icon-name="ic_arrow_left"
        main-color="none"
        text-color="currentColor"
        :hover-text-color="NebraskaColors.elementPrimary"
        :has-hover="true"
        :hover-color="NebraskaColors.backgroundHover"
        data-testid="back-button"
        @click="onBackClick"
      />
    </template>

    <template #center>
      <span>Me ajuda</span>
    </template>
  </NavBar>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import { NavBar, RoundedIcon } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  name: 'HelpCenterNavBar',
  components: { NavBar, RoundedIcon }
})
export default class HelpCenterNavBar extends Vue {
  onBackClick() {
    this.$router.back();
  }

  get NebraskaColors() {
    return NebraskaColors;
  }
}
</script>

<style lang="less" scoped>
.navbar {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 20;

  * {
    color: @text-primary;
  }
}
</style>
